export const COMMENTS = 'comments'
export const OUTLINE = 'outline'
